
import { Badge } from "@/components/ui/badge";

interface AppSearchResult {
  bundleId: string;
  appName: string;
  iconUrl?: string;
  trackId?: number | null;
}

interface AppSearchResultsProps {
  searchQuery: string;
  apps: AppSearchResult[];
  selectedApps: AppSearchResult[];
  onAppSelect: (app: AppSearchResult) => void;
}

export const AppSearchResults = ({ 
  searchQuery, 
  apps, 
  selectedApps, 
  onAppSelect 
}: AppSearchResultsProps) => {
  if (searchQuery.length >= 2 && apps.length === 0) {
    return (
      <div className="text-sm text-gray-500 p-3 text-center">
        No apps found in catalog
      </div>
    );
  }

  if (searchQuery.length > 0 && apps.length > 0) {
    return (
      <div className="border rounded-lg bg-white shadow-sm max-h-64 overflow-y-auto">
        {apps.map((app) => {
          const isSelected = selectedApps.some(
            selected => selected.bundleId === app.bundleId
          );
          
          return (
            <button
              key={app.bundleId}
              type="button"
              onClick={() => onAppSelect(app)}
              disabled={isSelected}
              className={`w-full p-3 text-left hover:bg-gray-50 border-b last:border-b-0 transition-colors ${
                isSelected ? 'opacity-50 cursor-not-allowed' : ''
              }`}
            >
              <div className="flex items-center space-x-3">
                {app.iconUrl ? (
                  <img
                    src={app.iconUrl}
                    alt={app.appName}
                    className="w-8 h-8 rounded"
                  />
                ) : (
                  <div className="w-8 h-8 bg-gray-100 rounded flex items-center justify-center">
                    <span className="text-xs text-gray-500">
                      {app.appName.charAt(0).toUpperCase()}
                    </span>
                  </div>
                )}
                <div className="flex-1 min-w-0">
                  <div className="font-medium text-gray-900 truncate">
                    {app.appName}
                  </div>
                  <div className="text-sm text-gray-500 truncate font-mono">
                    {app.bundleId}
                  </div>
                </div>
                {isSelected && (
                  <Badge variant="secondary" className="text-xs">
                    Selected
                  </Badge>
                )}
              </div>
            </button>
          );
        })}
      </div>
    );
  }

  return null;
};
